import React, { useState, useEffect, useContext } from 'react';

import { Button } from 'web-store-modules/packages/web-store-ui-library';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './SpotifyPlayerModal.css';
import { AppContext } from "../../../../AppContext.jsx";
import { MusicIconClicked } from '../../../../utils/Analytics';


const SpotifyPlayerModal = () => {
   
    const [fontStyles, setFontStyles] = useState();
    const { showSpotifyModal,setSpotifyModalVisibility } = useContext(AppContext);

    useEffect(() => {
        fetchFontStyles();
    }, []);

    useEffect(() => {
        if(showSpotifyModal){
            setTimeout(() => {
                document.getElementsByTagName('canvas')[0].style.filter = 'blur(5px)';
                document.getElementsByClassName("spotify")[0].style.setProperty('display', 'block', 'important');
            }, 0);
            
        }else{
            setTimeout(() => {
                document.getElementsByTagName('canvas')[0].style.filter = '';
                document.getElementsByClassName("spotify")[0].style.setProperty('display', 'none', 'important');
            }, 0);
        }
    }, [showSpotifyModal]);


    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const handleClick = () => {
        MusicIconClicked('Back to experience button clicked');
        setSpotifyModalVisibility(!showSpotifyModal);
    }

    const productButton = () => {
        return (
            <div className="product-button-container"><Button
                hoverStyleChange={true}
                onClick={handleClick}
                primaryColor={'#000000'}
                secondaryColor={'#C3A07D'}
                className="text-marker-button flex-center obsessvr-regularFont full-width pointer product-button"
                style={{ padding: '0', margin: '0', fontFamily: 'Prelo Bold' }}
                primaryBorderColor='white'
                secondaryBorderColor='white'
                primaryBorderWidth='0px'
                secondaryBorderWidth='0px'
                insetBorder={true}
                padded={false}
            >
                <p className='obsessvr-regularFont' style={{color: '#ffffff', fontFamily: 'Prelo Bold', fontSize: '16px'}}>
                    BACK TO EXPERIENCE
                </p>
            </Button></div>
        )
    }

    const spotifyMusicContainer = () => {
        return (
            <div className='spotify-music-container'>
               <iframe src="https://open.spotify.com/embed/playlist/2CITHJuZejwXafbprR5OHD?utm_source=generator" width="100%" height="380" frameBorder="0"  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>
            </div>
        )
    }



    const renderModalContent = () => {
        return (
            <div className='spotify-modal-content' style={{ textAlign: 'center' }} >            
                {spotifyMusicContainer()}
                {productButton()}
            </div>
        )
    }
    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName="spotify-modal-container" isOpaque
            textPopup hideCloseIcon isSpotifyModal={true}>
            {/* <ModalOverlay /> */}
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default SpotifyPlayerModal;


